import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
import { useEffect, useState } from 'react'
import MaskInput, { Masks } from 'react-native-mask-input'

const MiInformationForm = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const { loading, postmionline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const intialValues = {
    driverlicense: '',
    newemployee: '',
    noofdependents: '',
    additionalamount: '',
    claimexemption: null,
    explain1: '',
    explain2: '',
    dateHired: ""
  }
  const options1 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]
  const options2 = [
    {
      key: 1,
      value: 'A Michigan income tax liability is not expected this year'
    },
    { key: 2, value: 'Wages are exempt from withholding' },
    {
      key: 3,
      value:
        'Permanent home (domicile) is located in the following Renaissance Zone'
    }
  ]
  const paschema = yup.object({
    driverlicense: yup
      .string()
      .required('Driver’s License Number is a required field'),
    newemployee: yup
      .string()
      .required('Are you a new employee is a required field'),
    noofdependents: yup
      .string()
      .required('Personal and dependent exemptions is a required field'),
    explain1: yup
      .string()
      .when('claimexemption', (claimexemption: any, schema) => {
        if (claimexemption == 1) {
          return schema.required('Enter the Explanation is a required field')
        }
        return schema.nullable()
      }),
    explain2: yup
      .string()
      .when('claimexemption', (claimexemption: any, schema) => {
        if (claimexemption == 2) {
          return schema.required('Enter Renaissance Zone is a required field')
        }
        return schema.nullable()
      }),
    dateHired: yup.string().when('newemployee', (newemployee: any, schema) => {
      if (newemployee == 1) {
        return schema.required("Hire date is a required field")
      }
      return schema.nullable()
    })
  })

  const formatDateForApi = (date) => {
    if (!date) return null;

    const [month, day, year] = date.split('/');

    if (!month || !day || !year) return null;

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'MI Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={paschema}
          onSubmit={async (values, actions) => {
            const data = {
              entityId: personalstore.personalData?.entityId,
              essUserKey: initializestore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              driverLicense: values?.driverlicense,
              newEmployee: values?.newemployee,
              noOfDependents: values?.noofdependents,
              additionalAmount: values?.additionalamount
                ? values?.additionalamount
                : 0,
              exempt: values?.claimexemption,
              explain1: values?.explain1,
              explain2: values?.explain2,
              DateHired: formatDateForApi(values?.dateHired)
            }

            const response = await postmionline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('MiInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <Card>
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '50%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Enter Driver’s License Number or State ID*'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.driverlicense}
                    onChangeText={(text) => {
                      props.handleChange('driverlicense')(text)
                    }}
                  />
                  {props.touched.driverlicense &&
                    props.errors.driverlicense && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.driverlicense}
                      </Text>
                    )}
                </View>
              </View>
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '52%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Are you a new employee?*'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <SelectKeyValue
                    title="Are you a new employee?"
                    options={options1}
                    selectedOption={mapSelectValue(
                      options1,
                      props.values.newemployee
                    )}
                    onSelect={(option: any) => {
                      props.setFieldValue('newemployee', option - 1)
                      props.setFieldValue('dateHired', "")
                    }}
                    textColor="primary"
                  />
                  {props.touched.newemployee && props.errors.newemployee && (
                    <Text style={globalStyles.dangerAlert}>
                      {props.errors.newemployee}
                    </Text>
                  )}
                </View>
              </View>
              {props.values.newemployee == 1 ? (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '48%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter date of hire'}
                    </Text>
                  </View>
                  <View style={{ width: '28%' }}>
                    <MaskInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.dateHired || ''}
                      onChangeText={props.handleChange('dateHired')}
                      mask={Masks.DATE_MMDDYYYY}
                      inputMode="numeric"
                      placeholder="MM/DD/YYYY"
                    />
                    {props.touched.dateHired && props.errors.dateHired && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.dateHired as string}
                      </Text>
                    )}
                  </View>
                </View>
              ) : (
                <></>
              )}
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '50%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Enter the number of personal and dependent exemptions*'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.noofdependents}
                    onChangeText={(text) => {
                      if (text === '' || /^\d+$/.test(text)) {
                        props.handleChange('noofdependents')(text)
                      }
                    }}
                    keyboardType="numeric"
                  />
                  {props.touched.noofdependents &&
                    props.errors.noofdependents && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.noofdependents}
                      </Text>
                    )}
                </View>
              </View>
              {(props.values.claimexemption === null || props.values.claimexemption === '') && (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Additional amount you want deducted from each pay'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additionalamount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additionalamount')(text)
                        }
                      }}
                    />
                    {props.touched.additionalamount &&
                      props.errors.additionalamount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalamount}
                        </Text>
                      )}
                  </View>
                </View>
              )}
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '52%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'I claim exemption from withholding'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <SelectKeyValue
                    title="I claim exemption from withholding"
                    options={options2}
                    selectedOption={mapSelectValue(
                      options2,
                      props.values.claimexemption
                    )}
                    onSelect={(option: any) => {
                      const val = option - 1
                      props.setFieldValue('claimexemption', val)
                      props.setFieldValue('explain1', '')
                      props.setFieldValue('explain2', '')
                      if (val !== null && val !== '') {
                        props.setFieldValue('additionalamount', '')
                      }
                    }}
                    textColor="primary"
                  />
                  {props.touched.claimexemption &&
                    props.errors.claimexemption && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.claimexemption as string}
                      </Text>
                    )}
                </View>
              </View>
              {props?.values?.claimexemption === 1 && (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Explain'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.explain1}
                      onChangeText={(text) => {
                        props.handleChange('explain1')(text)
                      }}
                    />
                    {props.touched.explain1 && props.errors.explain1 && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.explain1}
                      </Text>
                    )}
                  </View>
                </View>
              )}
              {props?.values?.claimexemption === 2 && (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter Renaissance Zone'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.explain2}
                      onChangeText={(text) => {
                        props.handleChange('explain2')(text)
                      }}
                    />
                    {props.touched.explain2 && props.errors.explain2 && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.explain2}
                      </Text>
                    )}
                  </View>
                </View>
              )}
              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? 'Submit Information' : 'Next'}
                    onPress={props.handleSubmit}
                  />
                </View>
              )}
            </Card>
          )}
        </Formik>
      </View>
    </KeyboardAwareScrollView>
  )
}

export default MiInformationForm
